import { render, staticRenderFns } from "./NavBread.vue?vue&type=template&id=646c3acf&"
import script from "./NavBread.vue?vue&type=script&lang=js&"
export * from "./NavBread.vue?vue&type=script&lang=js&"
import style0 from "./NavBread.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports